import { gsap } from 'gsap'
import { deepMerge } from 'js/utils/Utils'

import Common from 'js/_core/Common'
import FadeInViewItem from 'js/modules/_base/effects/FadeInViewItem'

const defaults = {
  instanceName: 'titleFadeAInViewItem',
  $names: {
    trigger: '[data-anim="title-mask-a-iv"]',
    maskIn: '.mask_in',
  },
}

export default class TitleMaskAInViewItem extends FadeInViewItem {
  constructor(options = {}) {
    super()
    this._iom = Common.iom3
    deepMerge(this, defaults, options)
  }

  init() {
    super.init()
  }

  destroy() {
    super.destroy()
  }

  setInitialStyle($el, index) {
    gsap.set($el, {
      opacity: 0,
    })
  }

  async animateIn($el, index) {
    requestAnimationFrame(() => {
      const $maskIn = $el.querySelectorAll(this.$names.maskIn)

      gsap.set($el, {
        opacity: 1,
        delay: 0.1,
      })

      if ($maskIn) {
        gsap.fromTo(
          $maskIn,
          {
            y: '100%',
            rotate: 0.001,
            force3D: false,
          },
          {
            y: '0%',
            force3D: false,
            duration: 1,
            delay: 0.1,
            ease: 'expo.out',
          }
        )
      }
    })
  }
}